"use strict";
/* This is a generated file, do not edit */
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DispenserRequest = void 0;
var Time_1 = require("../../builtin_interfaces/msg/Time");
var DispenserRequestItem_1 = require("../../rmf_dispenser_msgs/msg/DispenserRequestItem");
var DispenserRequest = /** @class */ (function () {
    function DispenserRequest(fields) {
        if (fields === void 0) { fields = {}; }
        this.time = fields.time || new Time_1.Time();
        this.request_guid = fields.request_guid || '';
        this.target_guid = fields.target_guid || '';
        this.transporter_type = fields.transporter_type || '';
        this.items = fields.items || [];
    }
    DispenserRequest.validate = function (obj) {
        var e_1, _a;
        try {
            Time_1.Time.validate(obj['time']);
        }
        catch (e) {
            throw new Error('in "time":\n  ' + e.message);
        }
        if (typeof obj['request_guid'] !== 'string') {
            throw new Error('expected "request_guid" to be "string"');
        }
        if (typeof obj['target_guid'] !== 'string') {
            throw new Error('expected "target_guid" to be "string"');
        }
        if (typeof obj['transporter_type'] !== 'string') {
            throw new Error('expected "transporter_type" to be "string"');
        }
        if (!Array.isArray(obj['items'])) {
            throw new Error('expected "items" to be an array');
        }
        try {
            for (var _b = __values(obj['items'].entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), i = _d[0], v = _d[1];
                try {
                    DispenserRequestItem_1.DispenserRequestItem.validate(v);
                }
                catch (e) {
                    throw new Error("in index ".concat(i, " of \"items\":\n  ") + e.message);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    DispenserRequest.FullTypeName = 'rmf_dispenser_msgs/msg/DispenserRequest';
    return DispenserRequest;
}());
exports.DispenserRequest = DispenserRequest;
/*
builtin_interfaces/Time time

# A unique ID for this request
string request_guid

# The unique name of the dispenser that this request is aimed at
string target_guid

# below are custom workcell message fields
string transporter_type
DispenserRequestItem[] items

*/
